import { ToastContainer } from "react-toastify";
import "./App.css";
import About from "./componets/About/About";
import Home from "./componets/Home/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HansDemo from "./componets/HansDemo/HansDemo";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function RouteLogger() {
  const location = useLocation();

  useEffect(() => {
    console.log("[VoltHertz route]", {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
      fullPath: `${location.pathname}${location.search}${location.hash}`,
    });
  }, [location]);

  return null;
}

function App() {
  return (
    <div className="App" style={{ width: "100%" }}>
      <ToastContainer />
      <Router>
        <RouteLogger />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/demo/hans/*" element={<HansDemo />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
